import { h } from "preact";
import { RoutableProps } from "preact-router";
import "./styles.scss";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand } from "../../../hooks";
import { manufacturingConfigurations } from "../../../App";
import { sidraLEG } from "../../../data/serialNumberSearchExecs";
import { ProductLabelReprint } from "../../../components/ProductLabelReprint";

export function SidraLEGReprint(props: RoutableProps) {
    const showSnackbar = useCommand<SnackbarShowCommand>();

    return (
        <div class="mezos-sit-reprint-page">
            <Snackbar doShow={showSnackbar} />
            <ProductLabelReprint
                showSnackbar={showSnackbar}
                configurations={manufacturingConfigurations["SidraLEG"]}
                execs={[sidraLEG.execs.elementSerialRegexPlain]}
                scanExecs={sidraLEG.orderedExecs}
            />
        </div>
    );
}
